/* global google */
// ToDo: Refactor this file.
import React from "react";
import autobanco from "../../../assets/img/autobanco.svg";
import sucursalDigital from "../../../assets/img/sucursal-digital.svg";
import atm from "../../../assets/img/atm.svg";
import agencia from "../../../assets/img/agencia.svg";
import kiosko from "../../../assets/img/kiosko.svg";
import cargadorElectrico from "../../../assets/img/estacion-de-carga.svg";
import servicioCajas from "../../../assets/img/servicio-cajas.svg";
import seleccionAutobanco from "../../../assets/img/selected-autobanco.svg";
import seleccionAtm from "../../../assets/img/selected-atm.svg";
import seleccionAgencia from "../../../assets/img//selected-agencia.svg";
import seleccionKiosko from "../../../assets/img/selected-kiosko.svg";
import formatSchedule from "../Global/formatSchedule";
import getIfOpen from "../Global/getIfOpen";
import getPostalAbbreviation from "../Global/getPostalAbbreviation";
import addQueryParams from "../Global/addQueryParams";
import { Marker } from "google-maps-react";

const Markers = (updateCurrentPopup, markers, currentBranch, updateCurrentBranch, langcode) => {
  const currentBranchImage = (marker,idx) =>{
    if(currentBranch === `${marker.entityLabel.toLowerCase().replace(/ /g, '')}-${idx.toString()}`){
      return marker.selectedIcon
    }else {
      return marker.icon
    }
  }
  const displayMarkers = () => {
    return markers.map((item) => {
      let branchType;
      if (item && item.fieldOfficeBranchType && typeof item.fieldOfficeBranchType === "string") {
        branchType = item.fieldOfficeBranchType;
      } else if (item.fieldOfficeBranchType) {
        branchType = item.fieldOfficeBranchType.entity.entityLabel;
      } else {
        branchType = null;
      }
      if (branchType) {
        switch (branchType) {
          case "RAPIBAC":
          case "RAPIBANCO":
            item['icon'] = kiosko;
            item['selectedIcon'] = seleccionKiosko;
            break;
          case "SUCURSALDIGITAL":
            item['icon'] = sucursalDigital;
            item['selectedIcon'] = seleccionAgencia;
            break;
          case "ATM":
          case "ATMFULL":
          case "ATMFULLCHEQUE":
            item['icon'] = atm;
            item['selectedIcon'] = seleccionAtm;
            break;
          case "SERVICIODECAJA":
          case "PUNTOS":
          case "EXTRA":
          case "CAJASEMPRESARIALES":
          case "AGENCIA" || "AGENCIAREFORMADOR":
          case "AGENCIAREFORMADOR":
            item['icon'] = agencia;
            item['selectedIcon'] = seleccionAgencia;
            break;
          case "KIOSKO":
            item['icon'] = kiosko;
            item['selectedIcon'] = seleccionKiosko;
            break;
          case "AUTOBANCO":
            item['icon'] = autobanco;
            item['selectedIcon'] = seleccionAutobanco;
            break;
        }
      } else {
        item['icon'] = servicioCajas;
        item['selectedIcon'] = servicioCajas;
      }
      return item;
    });
  }
  return (
    displayMarkers().map((marker, idx) => {
      const formatedDate = formatSchedule(marker.fieldSchedule);
      const formatedCounterDate = formatSchedule(marker.fieldScheduleCounter);
      let scheduleState = getIfOpen(formatedDate.currentDate, null, formatedDate.otherDaysOpen);
      let scheduleCounterState = getIfOpen(formatedCounterDate.currentDate, null, formatedCounterDate.otherDaysOpen);
      let branchScheduleState = '';
      if (scheduleState === 'Abierto' || scheduleCounterState === 'Abierto') {
        branchScheduleState = 'Abierto';
      } else if (scheduleState === 'NotFound' && scheduleCounterState === 'NotFound') {
        branchScheduleState = 'NotFound';
      } else {
        branchScheduleState = 'Cerrado';
      };
      const closeMarkerPoint = marker.fieldElectricCharger? new google.maps.Point(40, 40) : new google.maps.Point(30, 30);
      const openAnchorPoint = marker.fieldElectricCharger? new google.maps.Point(58, 64) : new google.maps.Point(48, 54);
      const openScaledSize = marker.fieldElectricCharger? new google.maps.Size(64, 64) : new google.maps.Size(64, 64);
      const closeMarkerSize = marker.fieldElectricCharger? new google.maps.Size(40, 40) : new google.maps.Size(30, 30);
      return (
        <Marker
          key={`marker-${idx.toString()}`}
          name={marker.entityLabel}
          onClick={(e) => {
            let type;

            if (marker.fieldOfficeBranchType && typeof marker.fieldOfficeBranchType === "string") {
              type = marker.fieldOfficeBranchType;
            } else if (marker.fieldOfficeBranchType) {
              type = marker.fieldOfficeBranchType.entity.entityLabel;
            } else {
              type = null;
            }
            // ToDo: This and cardlist option should point to the ID inside the branches variables, pick the one related and use those values.
            updateCurrentPopup({
              entityId: marker.entityId,
              entityLabel: marker.entityLabel,
              fieldAddress: marker.fieldAddress,
              fieldSchedule: formatedDate,
              fieldScheduleCounter: formatedCounterDate,
              queryFieldServices: marker.queryFieldServices,
              fieldCoordinates: marker.fieldCoordinates,
              fieldOfficeBranchType: type,
              image: marker.fieldOfficeBranchImage,
              deactivateSchedule: marker.fieldDesactivarHorario,
              aditionalInfo: marker.fieldDisclamer,
              deactivatePhone: marker.fieldDesactivarTelefono,
              mobilePhone: marker.fieldMobilePhone,
              principalPhone: marker.fieldPrincipalPhone,
              geographyLocation: marker[`fieldGeographyLocation${getPostalAbbreviation(langcode)}`],
              fieldLocation: marker.fieldLocation,
              branchScheduleState,
              hasElectricCharger: marker.fieldElectricCharger
            })
            updateCurrentBranch(e.id);
            addQueryParams({
              "nombre-sucursal": marker.entityLabel,
              "id-sucursal": marker.entityId
            });
          }}
          id={`${marker.entityLabel.toLowerCase().replace(/ /g, '')}-${idx.toString()}`}
          position={{
            lat: marker.fieldCoordinates.lat,
            lng: marker.fieldCoordinates.lng
          }}
          icon={{
            url: marker.fieldElectricCharger? cargadorElectrico :currentBranchImage(marker,idx),
            anchor: currentBranch === `${marker.entityLabel.toLowerCase().replace(/ /g, '')}-${idx.toString()}` ? openAnchorPoint : closeMarkerPoint,
            scaledSize: currentBranch === `${marker.entityLabel.toLowerCase().replace(/ /g, '')}-${idx.toString()}` ? openScaledSize :  closeMarkerSize
          }}
        />
      )
    })
  );
};

export default Markers;
